import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum MoveSmallIconVariant {
  LEFT = 'left',
  RIGHT = 'right',
}

export interface IMoveSmallIconProps extends IConDefaultType {
  variant?: MoveSmallIconVariant;
}

function MoveSmallIcon({
  color,
  className,
  size = 30,
  rotate,
  flip,
  variant = MoveSmallIconVariant.LEFT,
}: IMoveSmallIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === MoveSmallIconVariant.LEFT && (
        <svg viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_3974_152365)">
            <circle cx="15" cy="15" r="10" fill="white" />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.2559 10.2441C17.5814 10.5695 17.5814 11.0972 17.2559 11.4226L13.6785 15L17.2559 18.5774C17.5814 18.9028 17.5814 19.4305 17.2559 19.7559C16.9305 20.0814 16.4028 20.0814 16.0774 19.7559L11.9107 15.5893C11.5853 15.2638 11.5853 14.7362 11.9107 14.4107L16.0774 10.2441C16.4028 9.91864 16.9305 9.91864 17.2559 10.2441Z"
            fill="#ADB0B8"
          />
          <defs>
            <filter
              id="filter0_d_3974_152365"
              x="1"
              y="3"
              //   width="28"
              //   height="28"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="2" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3974_152365" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3974_152365" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {variant === MoveSmallIconVariant.RIGHT && (
        <svg viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_3974_152366)">
            <circle cx="15" cy="15" r="10" fill="white" />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.7441 19.7559C12.4186 19.4305 12.4186 18.9028 12.7441 18.5774L16.3215 15L12.7441 11.4226C12.4186 11.0972 12.4186 10.5695 12.7441 10.2441C13.0695 9.91864 13.5972 9.91864 13.9226 10.2441L18.0893 14.4107C18.4147 14.7362 18.4147 15.2638 18.0893 15.5893L13.9226 19.7559C13.5972 20.0814 13.0695 20.0814 12.7441 19.7559Z"
            fill="#ADB0B8"
          />
          <defs>
            <filter
              id="filter0_d_3974_152366"
              x="1"
              y="3"
              //   width="28"
              //   height="28"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="2" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3974_152366" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3974_152366" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
    </i>
  );
}

export default MoveSmallIcon;
